import { render, staticRenderFns } from "./PanelLocale.vue?vue&type=template&id=1841c940&scoped=true&"
import script from "./PanelLocale.vue?vue&type=script&lang=js&"
export * from "./PanelLocale.vue?vue&type=script&lang=js&"
import style0 from "./PanelLocale.vue?vue&type=style&index=0&id=1841c940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841c940",
  null
  
)

export default component.exports